/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for check icon.
 *
 * @author Ramani Govindaraju
 */
const Check = props => (
  <SvgIcon viewBox="0 0 12 13" {...props}>
    <path
      d="M10.182 1.196l-6.339 8.99-2.11-2.275A1 1 0 1 0 .266 9.27l2.95
      3.182a1 1 0 0 0 1.55-.103l7.051-10a1 1 0 1 0-1.635-1.153z"
    />
  </SvgIcon>
);

export default Check;



// WEBPACK FOOTER //
// ./src/js/icons/Check.jsx